import { ThemeBlueprint } from '@backstage/plugin-app-react';
import {
  createUnifiedTheme,
  palettes,
  UnifiedThemeProvider,
} from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { brand, darkPalette } from '../home/brand';
import { templatePageTheme } from './pageTheme';

// Sidebar in the Ekimetrics blue, same for the light and dark themes.
const navigation = {
  background: brand.japaneseBlue,
  indicator: brand.accent,
  color: '#c5cde0',
  selectedColor: '#ffffff',
  navItem: { hoverBackground: brand.japaneseBlueLight },
  submenu: { background: brand.japaneseBlueDark },
};

const lightTheme = createUnifiedTheme({
  palette: { ...palettes.light, navigation },
  pageTheme: templatePageTheme,
});

const darkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    navigation,
    primary: { main: darkPalette.primary, dark: darkPalette.primaryDark },
    secondary: { main: brand.accent },
    background: {
      default: darkPalette.pageBackground,
      paper: darkPalette.surface,
    },
    border: darkPalette.border,
  },
  pageTheme: templatePageTheme,
});

// Replaces the default light/dark themes (theme:app/light, theme:app/dark,
// disabled in app-config.yaml) so catalog/scaffolder tiles use templatePageTheme.
// Named distinctly (not "light"/"dark") to avoid colliding with those disabled
// built-in extension ids, which both live under the same pluginId ("app").
export const LightTheme = ThemeBlueprint.make({
  name: 'light-custom',
  params: {
    theme: {
      id: 'light',
      title: 'Light Theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const DarkTheme = ThemeBlueprint.make({
  name: 'dark-custom',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark Theme',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});
